<script>
import StoreSelectorModal from '@phoenix/mixins/components/store/StoreSelectorModal';

export default {
  mixins: [StoreSelectorModal],

  data() {
    return {
      followBoutiqueAppointmentUrl: false,
      productReference: null,
    };
  },

  computed: {
    modalOptions() {
      return {
        onShown() {
          const storeSelectorModal = document.querySelector(`#store-selector-modal`);
          if (storeSelectorModal) {
            const focusEl = storeSelectorModal.querySelector('#store-selector-search');
            if (focusEl) {
              focusEl.focus();
            }
          }
        },
        onShow: (event) => {
          const props = this.getModalProps(event);
          this.followBoutiqueAppointmentUrl = !!props?.followBoutiqueAppointmentUrl;
          this.productReference = props?.productReference;
        },
        onHidden: () => this.reset(),
      };
    },

    modalClasses() {
      return ['find-a-boutique-modal'];
    },
  },

  methods: {
    storeClick(store) {
      this.setStorePageId(store.id);
      this.close();
    },
  },
};
</script>

<template>
  <modal :id="id" :title="$t('Store.storeSelector.findYourStore')" :options="modalOptions" :classes="modalClasses">
    <template #content>
      <store-finder-in-modal :keyword="query" @submit="search" />

      <store-results-in-modal
        :stores="stores"
        :is-loading="isLoading"
        :display-no-result="query !== null"
        :follow-store-link-on-click="false"
        :follow-boutique-appointment-url="followBoutiqueAppointmentUrl"
        :product-reference="productReference"
        :no-result-title="$t('Store.storeSelector.noStoreFound')"
        :no-result-text="$t('Store.storeSelector.noStoreHaveBeenFound')"
        @store-click="storeClick"
      />
    </template>
  </modal>
</template>

<style>
.modal__header.modal__header--no-body {
  padding-bottom: 0;
  border: 0;
}
</style>
